var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 1.5625L8.125 8.4375",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18359 2.24611C4.45394 2.20676 4.7268 2.18717 5 2.18752C6.50519 2.18347 7.9506 2.77624 9.01953 3.83596",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.980469 3.83594C1.51032 3.31129 2.13809 2.89586 2.82813 2.61328",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 4.17969C6.60327 4.34362 7.20899 4.68222 7.69531 5.16016",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30469 5.16016C2.83202 4.64418 3.49632 4.29033 4.21875 4.14062",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62891 6.48826C3.98118 6.15192 4.44465 5.95658 4.93139 5.9393C5.41814 5.92202 5.8943 6.084 6.26953 6.39451",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.28125C5.25888 8.28125 5.46875 8.07138 5.46875 7.8125C5.46875 7.55362 5.25888 7.34375 5 7.34375C4.74112 7.34375 4.53125 7.55362 4.53125 7.8125C4.53125 8.07138 4.74112 8.28125 5 8.28125Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSlash);
export default __webpack_public_path__ + "static/media/WifiSlash.187a50f69512625ec65e11d2ad70b009.svg";
export { ForwardRef as ReactComponent };